// Editable payload for Oregon Form OR-AUTH-INFO (Authorization for Tax
// Information). snake_case keys mirror `apps/forms/mappings/form_orauthinfo.py`
// `build_defaults` exactly (the submission `data` blob is passed through
// verbatim, no snake→camel mapping). OR-AUTH-INFO is disclosure-only and prints
// a single representative — so there are no acts/exceptions and no per-rep
// active/designation columns like 2848/8821.

import type { PractitionerDesignation } from "@/features/forms/types";

/** A practitioner assigned to the client, offered as the single rep choice. */
export interface FormOrauthinfoRepresentative {
  /** The backing Practitioner id (contact details are looked up from it server-side). */
  practitioner: string;
  active: boolean;
  name: string;
  designation: PractitionerDesignation | "";
  other_id: string;
  other_type: string;
}

/** One "Authorization Limitations" row: a tax year/period + a tax program. */
export interface FormOrauthinfoMatter {
  tax_years: string;
  tax_programs: string;
}

export interface FormOrauthinfoData {
  generate_for: "taxpayer" | "spouse";
  /** The single selected representative's practitioner id ("choose one per form"). */
  active_rep: string;
  representatives: FormOrauthinfoRepresentative[];
  matters: FormOrauthinfoMatter[];
  /** Whether the taxpayer's tax ID is an SSN or ITIN (only the last four print). */
  tin_type: "SSN" | "ITIN";
  /** Business Identification Number (business clients only). */
  bin: string;
}

/**
 * How many limitation rows fit on the form before spilling to a continuation
 * sheet (mirrors `_MAX_MATTERS` in the backend mapper).
 */
export const MAX_ORAUTHINFO_MATTERS = 4;
